define('score_bootstrap/Utils/UrlHelper',["jquery"], function ($) {
    "use strict";

    var defaultHashDelimiter = "/";

    function createSetRegExp(urlParam) {
        /*
        [\?|&]                      Character set - Match any of these characters: [?|&]
        (urlParam=[^&]+|$)          Capturing parenthesis. (x) matches x and remembers the match.
            urlParam=               Explicit match
            [^&]+                   Negated character set. The + quantifier causes this item to be matched 1 or more times (greedy).
            |                       Or
            $                       Matches end of input.
        */
        return new RegExp("([\?|&])(" + urlParam + "=[^&#]+|$)", "gi");
    }

    function createGetRegExp(urlParam) {
        return new RegExp("[\?|&]" + urlParam + "=([^&#]+|$)", "gi");
    }
    

    function UrlHelper() {
        return undefined;
    }

    UrlHelper.prototype.getHashAsObject = function getHashAsObject(delimiter) {
        return decodeURI(window.location.hash.slice(1))
            .split(delimiter || defaultHashDelimiter)
            .reduce(function (result, value) {
                value = value.split("=");
                if (value.length === 2) {
                    result[value[0]] = value[1];
                }

                return result;
            }, {});
    };

    UrlHelper.prototype.getObjectAsHash = function getObjectAsHash(obj, delimiter) {
        var hash = "", del = delimiter || defaultHashDelimiter;
        $.each(obj, function (key, value) {
            hash = hash + key + "=" + value + del;
        });

        return encodeURI(hash.substring(0, hash.length - del.length)); // cut off trailing delimiter
    };

    UrlHelper.prototype.getHashValue = function getHashValue(paramName, delimiter) {
        return this.getHashAsObject(delimiter || defaultHashDelimiter)[paramName];
    };

    UrlHelper.prototype.setHashValue = function setHashValue(location, paramName, value, delimiter) {
        /**
         * location    - required, https://developer.mozilla.org/en-US/docs/Web/API/Location item
         * paramName   - required, parameter name
         * value       - required, parameter value
         * delimeter   - optional, character delimiting hash parameters
         */

        if (typeof(location.hash) !== "string") {
            throw new Error("location must implement Location");
        }

        var hash = this.getHashAsObject(delimiter);
        if (!value) {
            delete hash[paramName];
        } else {
            hash[paramName] = value;
        }

        var currentHash = this.getObjectAsHash(hash, delimiter || defaultHashDelimiter);
        if (!currentHash) {
            this.removeHash();
        } else {
            location.hash = currentHash;
        }
    };

    UrlHelper.prototype.getUrlParameters = function getUrlParameters(location, urlParam) {
        urlParam = decodeURIComponent(urlParam);
        var regExp = createGetRegExp(urlParam), url = location.href, results = [], value = regExp.exec(url);
        while (value) {
            results.push(value[1]);
            value = regExp.exec(url);
        }

        return results.map(decodeURIComponent);
    };

    UrlHelper.prototype.setUrlParameters = function setUrlParameter(location, urlParam, value) {
        value = encodeURIComponent(value);
        if (location === undefined || location === null) {
            throw new Error("No location URL implemented");
        }

        var url = location.href, regExp = createSetRegExp(urlParam);

        // remove hash from localtion.href, since it can be a window.location.href, as well as a "a" HTML element.
        // later on we will restore hash from the window.location.href
        url = url.replace(/\#.+/, '');

        // Remove anchor
        var anchor = '';
        var hashPosition = window.location.href.indexOf('#');

        if (~hashPosition) {
            anchor = window.location.href.substring(hashPosition + 1);
            //url = window.location.href.substring(0, hashPosition);
        }

        // Clear out all current instances of this param in the query string
        if (regExp.test(url)) {
            url = url.replace(regExp, "$1");
            // If query string was something like ?param=value&otherparam=othervalue and ew removed param=value then we would end up with ?&
            if (url.indexOf("?&") > -1) {
                url = url.replace("?&", "?");
            }
            if (url.indexOf("&&") > -1) {
                url = url.replace("&&", "&");
            }
        }

        if (value) {
            if (url.indexOf("?") < 0) {
                url += "?";
            } else if (new RegExp("[\?&]").test(url.slice(-1)) === false) {
                url += "&";
            }
            url += (urlParam + "=" + value);
        }

        // Search by text query cannot be triggered if filter has preselected values in it
        // In case we press 'Enter' or click on the 'Search' button we redirect without hash
        var buttonConditions = location.classList && location.classList.contains("score-button") || false;
        // If it is a simple anchor - leave the hash part, otherwise erase the hash part because it might have Facet filter
        var isSimpleAnchor = !/[=&]/.test(anchor);

        // Append anchor back to url
        if (~hashPosition && (!buttonConditions || isSimpleAnchor)) {
            url += '#' + anchor;
        }

        if (window.location.pathname === location.pathname) {
            window.history.replaceState(null, document.title, url);
        }
        return url;
    };

    UrlHelper.prototype.removeHash = function() {
        var scrollV, scrollH, loc = window.location;
        if ("pushState" in history)
            history.pushState("", document.title, loc.pathname + loc.search);
        else {
            // Prevent scrolling by storing the page's current scroll offset
            scrollV = $(window).scrollTop();
            scrollH = $(window).scrollLeft();

            loc.hash = "";

            // Restore the scroll offset, should be flicker free
            $(window).scrollTop(scrollV);
            $(window).scrollLeft(scrollH);
        }
    };

    UrlHelper.prototype.SortDirectionKey = "direction";
    UrlHelper.prototype.SortTypeKey = "sort";

    return new UrlHelper(); // singleton
});
